import { gql, useMutation } from 'urql';

export const GENERATE_FORM_LINKS_MUTATION = gql`
  mutation GenerateFormLinks($eventId: Int!, $count: Int!) {
    generateFormLinks(input: { eventId: $eventId, count: $count }) {
      linkToken
    }
  }
`;

interface GenerateFormLinksVariables {
  eventId: number;
  count: number;
}

interface GenerateFormLinksResponse {
  generateFormLinks: Array<{
    linkToken: string;
  }>;
}

export const useGenerateFormLinks = () => {
  const [{ data, error, fetching }, executeMutation] = useMutation<
    GenerateFormLinksResponse,
    GenerateFormLinksVariables
  >(GENERATE_FORM_LINKS_MUTATION);

  const generateFormLinks = (variables: GenerateFormLinksVariables) => {
    return executeMutation(variables);
  };

  return {
    data: data?.generateFormLinks,
    error,
    fetching,
    generateFormLinks,
  };
};
